import { CareProType } from "Components/CareProSearchDropdown/types";

const getFullName = (first: string, last: string): string => {
  return `${first} ${last}`.toLowerCase();
}

export const searchCareProsList = (enteredQuery: string, noVisitList: Array<CareProType>, visitedList: Array<CareProType>): any => {
  if (enteredQuery.length === 0) {
    return { preferred_cps_list_has_not_visited: noVisitList, preferred_cps_list_has_visited: visitedList }
  }

  const query = enteredQuery.toLowerCase();

  const deepCloneOfVisitedList = structuredClone(visitedList);
  let listOfMatchingCareProsVisited = [];

  listOfMatchingCareProsVisited = deepCloneOfVisitedList.filter((carepro: CareProType) => getFullName(carepro.first_name, carepro.last_name).includes(query));

  const deepCloneOfNoVisitList = structuredClone(noVisitList);
  let listOfMatchingCareProsNoVisit = [];

  listOfMatchingCareProsNoVisit = deepCloneOfNoVisitList.filter((carepro: CareProType) => getFullName(carepro.first_name, carepro.last_name).includes(query));

  return {
    preferred_cps_list_has_not_visited: listOfMatchingCareProsNoVisit, preferred_cps_list_has_visited: listOfMatchingCareProsVisited
  }
}